module.exports = __webpack_public_path__ + "img/img_32389_0_132.6ab40400.png";